export default __webpack_public_path__ + "static/media/1819 spice rack top.7d556330.png";